/* eslint-disable import/prefer-default-export */
export const filterListBy = (list, key, search) => {
  if (!search) return list;

  return list.filter((item) => {
    if (!item[key]) return false;

    const haystack = item[key]
      .split(',')
      .map((str) => str.trim().toLowerCase());
    return haystack.includes(search.trim().toLowerCase());
  });
};

/* use for categories on bootstrapper app */
export const getReserveCategory = (categories) => {
  let category = '';

  if (categories && categories.length > 0) {
    if (categories.indexOf('centralised') !== -1) {
      category = 'centralised';
    } else if (categories.indexOf('official') !== -1) {
      category = 'official';
    } else if (categories.indexOf('shared') !== -1) {
      category = 'shared';
    } else if (categories.indexOf('personal') !== -1) {
      category = 'personal';
    }
  }
  return category;
};

/* use for type on bootstrapper app */
export const getReserveTypeCategory = (categories) => {
  let type = '';

  if (categories && typeof categories === 'string') {
    categories = categories.split(',');
  }
  if (categories.indexOf('support') !== -1) {
    type = 'support';
  } else if (categories.indexOf('guide') !== -1) {
    type = 'guide';
  } else if (categories.indexOf('talk') !== -1) {
    type = 'talk';
  } else if (categories.indexOf('sunshine') !== -1) {
    type = 'sunshine';
  } else {
    type = 'application';
  }
  return type;
};

// cleaning resources obj
export const resourceClean = (obj) => {
  const newObj = [];
  Object.keys(obj).forEach((key, i) => {
    if (Object.keys(obj[key]).length === 0) {
      delete obj[key];
      return;
    }
    newObj[i] = {
      name: key,
      resource: obj[key]
    };
  });
  return newObj;
};
